import React, { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase-config";
import HomeSnapshot from "./HomeSnapshot";
import HomeSnapshotLoader from "./HomeSnapshotLoader";

export default function LastMonthCPI() {
  const [cpi, setCpi] = useState();
  const [loading, setLoading] = useState(false);
  const currentDate = new Date();
  let year;

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  let lastMonth;

  if (currentDate.getMonth() === 0) {
    year = currentDate.getFullYear() - 1;
    lastMonth = "December";
  } else {
    year = currentDate.getFullYear();
    lastMonth = months[currentDate.getMonth() - 1];
  }

  useEffect(() => {
    setLoading(true);
    async function getDocuments() {
      const q = query(
        collection(db, "consumer-price-index"),
        where("country", "==", "Kenya"),
        where("year", "==", year),
        where("month", "==", lastMonth)
      );
      const allDocs = [];
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        allDocs.push(doc.data());
      });

      if (allDocs.length > 0) {
        setCpi(allDocs[0].cpi);
      }
      setLoading(false);
    }
    getDocuments();
  }, [lastMonth, year]);

  return loading ? (
    <HomeSnapshotLoader />
  ) : cpi !== undefined ? (
    <HomeSnapshot data={cpi} description={`${lastMonth} ${year} CPI`} />
  ) : (
    <></>
  );
}
